module.exports = __webpack_public_path__ + "static/media/cluster-diagram.e042ce5e.png";